module.exports = __webpack_public_path__ + "static/img/KL.80f82786.png";